import { render, staticRenderFns } from "./AppModalConfig.vue?vue&type=template&id=0958db30&scoped=true"
import script from "./AppModalConfig.vue?vue&type=script&lang=js"
export * from "./AppModalConfig.vue?vue&type=script&lang=js"
import style0 from "./AppModalConfig.vue?vue&type=style&index=0&id=0958db30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958db30",
  null
  
)

export default component.exports